<template>
  <fragment>
    <mc-app-header title="Add Concept">
      <template #right>
        <div class="level-item">
          <b-button
            :loading="concepts.submitting"
            type="is-primary"
            @click="addConceptHandler"
          >
            Add
          </b-button>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="add-concept section">
        <form class="mc-container" @submit.prevent="addConceptHandler">
          <b-field label="Topic">
            <mc-topic-select v-model="topic" />
          </b-field>
          <b-field label="Name">
            <b-input
              v-model="name"
              icon="format-title"
              placeholder="Name"
              type="text"
            />
          </b-field>
          <b-field label="Poster">
            <mc-image-input
              v-model="poster"
              icon="image"
              placeholder="Poster Link"
              type="POSTER"
            />
          </b-field>
        </form>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data: function() {
    return {
      name: '',
      poster: '',
      topic: null
    };
  },
  computed: {
    ...mapState(['concepts'])
  },
  methods: {
    ...mapActions('concepts', ['addConcept']),
    async addConceptHandler() {
      try {
        await this.addConcept({
          name: this.name,
          poster: this.poster,
          topic: this.topic
        });
        this.$buefy.toast.open({
          message: 'Concept added successfully!',
          type: 'is-success'
        });
        this.$router.replace(`/concepts/edit/${this.concepts.newConceptId}`);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to add concept!',
          type: 'is-danger'
        });
      }
    }
  },
  created() {
    const { topic } = this.$route.query;
    if (topic) {
      const [id, name] = topic.split('_');
      this.topic = { id, name };
    }
  }
};
</script>
